export const required = {
  default: "O campo é obrigatório.",
};
